import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Voy a tener que dejarlo llorar?',
    a: 'No. El llanto de pánico se atiende de inmediato. El protocolo te enseña a acompañar su pequeña queja de cambio sin abandonarlo.'
  }, {
    q: '¿Funciona si hacemos colecho?',
    a: 'Sí, el mecanismo de ventanas biológicas funciona igual sin importar dónde duerma el bebé.'
  }, {
    q: '¿Es un libro largo?',
    a: 'No, es una guía de implementación rápida diseñada para leerse en el móvil con una sola mano.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 px-6 max-w-2xl mx-auto" data-id="element-30">
      <FadeIn data-id="element-31">
        <h2 className="text-3xl sm:text-4xl text-center text-taupe mb-10" data-id="element-32">
          Preguntas frecuentes
        </h2>
      </FadeIn>

      <div className="space-y-4" data-id="element-33">
        {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-34">
            <div className="bg-white rounded-2xl shadow-sm border border-sage/10 overflow-hidden" data-id="element-35">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-36">
                <span className="font-serif text-lg text-taupe pr-4" data-id="element-37">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-38">
                  <ChevronDownIcon className="w-5 h-5 text-sage shrink-0" data-id="element-39" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-40">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-41">
                    <div className="px-6 pb-5 text-taupe/80 leading-relaxed border-t border-sage/5 pt-3" data-id="element-42">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}